import { render, staticRenderFns } from "./ReceiptSupervisionCodeList.vue?vue&type=template&id=76bb288f"
import script from "./ReceiptSupervisionCodeList.vue?vue&type=script&lang=js"
export * from "./ReceiptSupervisionCodeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports